export const ROOT = 'common/validate';

export const FETCH_VALIDATE_REQUEST = `${ROOT}/FETCH_VALIDATE_REQUEST`;
export const FETCH_VALIDATE_FAILURE = `${ROOT}/FETCH_VALIDATE_FAILURE`;
export const FETCH_VALIDATE_SUCCESS = `${ROOT}/FETCH_VALIDATE_SUCCESS`;

export const CLEAR_VALIDATE_DATA = `${ROOT}/CLEAR_VALIDATE_DATA`;
